import React, { type FC, useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { checkStatus } from 'pc-sales/store/actions/user';
import { getSetting } from 'pc-sales/store/actions/system';
import { Loading } from 'common/components';
import App from 'pc-sales/pages/App';
import i18n from 'pc-sales/pages/App/i18n';
import locales from 'pc-sales/locales';
import Login from 'pc-sales/pages/Login';
import expendMath from 'common/utils/formatter/expendMath';
import { verifyCookieUserInfoStatus } from 'pc-sales/utils/auth';
import type { ICookieUserInfo } from '../../../types/auth';
import GlobalMfaModal from 'pc-sales/pages/App/GlobalMfaModal';

interface RootProps {
    isCheckingStatus: boolean;
    isLocaleLoading: boolean;
    appearance: Record<string, unknown>;
    cookieUserInfo: ICookieUserInfo;
    checkStatus: () => void;
    getSetting: (params: unknown) => void;
}

const Root: FC<RootProps> = ({
    isCheckingStatus,
    isLocaleLoading,
    appearance,
    cookieUserInfo,
    checkStatus,
    getSetting,
}) => {
    const [isInited, setIsInited] = useState(false);

    const verifyCookieAndGetSetting = async () => {
        if (!isCheckingStatus) {
            await verifyCookieUserInfoStatus(cookieUserInfo);
            setIsInited(true);

            getSetting({
                keys: ['Crm_Appearance', 'PlatForm_Company', 'PlatForm_Design', 'Crm_Security', 'Passport_Security'],
            });
        }
    };

    useEffect(() => {
        checkStatus();
        expendMath();
    }, []);

    useEffect(() => {
        verifyCookieAndGetSetting().catch();
    }, [isCheckingStatus, getSetting]);

    if (!cookieUserInfo) return <Login />;
    const { utype } = cookieUserInfo;

    const isLoading = !isInited || isLocaleLoading || !appearance;
    const isSsoVerified = !!utype;

    if (isLoading) return <Loading debounce={800} />;
    if (isSsoVerified)
        return (
            <>
                <App {...appearance} />
                <GlobalMfaModal />
            </>
        );
    return <Login />;
};

const mapStateToProps = (state: any) => {
    return {
        isCheckingStatus: state.user.get('isCheckingStatus'),
        appearance: state.system.getIn(['setting', 'Crm_Appearance']),
        cookieUserInfo: state.user.get('status'),
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    ...bindActionCreators(
        {
            checkStatus: checkStatus.init,
            getSetting: getSetting.init,
        },
        dispatch,
    ),
});

export default i18n(locales)(connect(mapStateToProps, mapDispatchToProps)(Root));
